module.exports = __webpack_public_path__ + "static/media/skycity.cbf4933d.png";